
import { Receipt } from "../../classes"

const ReceiptModule = {
  namespaced: true,
  state: {
    receipts: null,
    receipt: null,
    receiptOverallMonthly: []
  },
  mutations: {
    setReceipts(state, receipts) {
      state.receipts = receipts || []
    },
    setReceiptOverallMonthly(state, receipts) {
      state.receipts = receipts || []
    },
    setReceipt(state, receipt) {
      state.receipt = receipt
      if (state.receipts && state.receipts.length) {
        let index = state.receipts.findIndex(i => i.objectId === receipt.objectId);
        state.receipts[index] = receipt;

        const temp = state.receipts
        state.receipts = []
        state.receipts = temp
      } else {
        state.receipts = [receipt]
      }
    },
    updateReceipt(state, receipt) {
      if (state.receipts && state.receipts.length) {
        let index = state.receipts.findIndex(i => i.objectId === receipt.objectId);
        state.receipts[index] = receipt;

        const temp = state.receipts
        state.receipts = []
        state.receipts = temp
      } else {
        state.receipts = [receipt]
      }
    },
    addReceipts(state, receipts) {
      state.receipts = state.receipts.concat(receipts)
    }
  },
  actions: {
    createReceipt: async ({ commit }, postData) => {
      try {
        var result = await Receipt.createReceipt(postData);
        commit('updateReceipt', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    updateReceipt: async ({ commit }, postData) => {
      try {
        var result = await Receipt.updateReceipt(postData);
        commit('updateReceipt', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    payReceipt: async ({ commit }, postData) => {
      try {
        var result = await Receipt.payReceipt(postData);
        commit('updateReceipt', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    unpaidReceipt: async ({ commit }, { id, note }) => {
      try {
        let result = await Receipt.unpaidReceipt({ id, note });
        commit('updateReceipt', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    getReceiptsBetweenDateByMarket: async ({ commit }, payload) => {
      try {
        var result = await Receipt.getReceiptsBetweenDateByMarket(payload);

        commit('setReceipts', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    getReceiptsBetweenDateByProject: async ({ commit }, { projectId, startDate, endDate }) => {
      try {
        var result = await Receipt.getReceiptsBetweenDateByProject(projectId, startDate, endDate);

        commit('setReceipts', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    getById: async ({ commit }, receiptId) => {
      try {
        var result = await Receipt.getReceipt(receiptId);
        commit('setReceipt', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    getDepositReceiptsByContracts: async ({ commit }, payload) => {
      try {
        var result = await Receipt.getDepositReceiptsByContracts(payload);
        commit('setReceipts', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    updateReceiptCustomerData: async ({ commit }, postData) => {
      try {
        var result = await Receipt.updateReceiptCustomerData(postData);
        commit('updateReceipt', result)
        return result;
      } catch (error) {
        throw error
      }
    },
    getReceiptOverallMonthly: async ({ commit }, payload) => {
      try {
        let receipts = await Receipt.getReceiptOverallMonthly(payload)
        commit("setReceiptOverallMonthly", receipts)
        return receipts
      } catch (error) {
        throw error
      }
    },
  },
  getters: {
    getReceipts: (state) => state.receipts,
    getReceiptOverallMonthly: (state) => state.receiptOverallMonthly,
  },
};
export default ReceiptModule;
